/**
 * The backend rejects null/empty/NaN and anything <= 0, since a zero-gram
 * product would price as weightless for shipping. Mirror that here so invalid
 * rows are caught before a request goes out.
 */
export const isValidWeight = (weight) => {
	if (weight === null || weight === undefined || weight === '') return false;
	const parsed = parseFloat(weight);
	return !isNaN(parsed) && parsed > 0;
};

/**
 * Rows are keyed by price_type_id (variant grain), which the listing endpoint
 * guarantees is present and unique per row.
 */
export const rowKey = (item) => String(item.price_type_id);

/**
 * Drop empty values so the request body only carries filters the user set —
 * the endpoint treats an absent key as "no filter" but an empty string as a
 * search term.
 */
export const getActiveFilters = (filters) => {
	const active = {};
	Object.entries(filters || {}).forEach(([key, value]) => {
		if (value === '' || value === null || value === undefined) return;
		active[key] = value;
	});
	return active;
};

export const HAS_WEIGHT_OPTIONS = [
	{value: '', label: 'All products'},
	{value: 'false', label: 'Missing weight'},
	{value: 'true', label: 'Has weight'},
];

/**
 * `weight` is stored in whatever unit the catalogue row carries, while
 * `weight_grams` is the normalised value. Show the raw pair so a row stored in
 * kg is visibly different from one already in grams.
 */
export const formatStoredWeight = (item) => {
	if (item.weight === null || item.weight === undefined) return '-';
	return `${item.weight}${item.weight_unit ? ` ${item.weight_unit}` : ''}`;
};

export const buildExportRows = (items) =>
	(items || []).map((item) => ({
		product_code: item.product_code || '',
		name: item.name || '',
		variant_name: item.variant_name || '',
		item_id: item.item_id,
		price_type_id: item.price_type_id,
		weight_grams: item.weight_grams ?? '',
		stored_weight: formatStoredWeight(item),
		has_weight: item.has_weight ? 'Yes' : 'No',
	}));
